(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var campaignKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ];
  var campaignStorageKey = 'cantina_campaign_context';
  var currentParams = new URLSearchParams(window.location.search);
  var campaignValues = {};
  var previousPermissions = {};
  var revokedCampaignKeys = {};

  campaignKeys.forEach(function (key) {
    var value = currentParams.get(key);
    if (value) campaignValues[key] = value;
  });

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function storageAllowedFor(key) {
    var privacy = customerPrivacy();
    if (!privacy) return false;

    try {
      if (key === 'gclid' || key === 'fbclid') {
        return typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed();
      }

      return (
        (typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) ||
        (typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
      );
    } catch (error) {
      return false;
    }
  }

  function refreshStoredCampaignContext() {
    if (!customerPrivacy()) {
      // API startup is unknown consent: do not read or change stored context.
      campaignKeys.forEach(function (key) {
        if (previousPermissions[key] === true) {
          delete campaignValues[key];
          revokedCampaignKeys[key] = true;
          previousPermissions[key] = false;
        }
      });
      return;
    }

    var stored = {};

    try {
      stored = JSON.parse(window.sessionStorage.getItem(campaignStorageKey) || '{}');
    } catch (error) {
      stored = {};
    }

    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) stored = {};

    campaignKeys.forEach(function (key) {
      var allowed = storageAllowedFor(key);

      if (!allowed) {
        delete stored[key];
        // Keep initial URL context pending consent, but discard it on revocation.
        if (previousPermissions[key] === true) {
          delete campaignValues[key];
          revokedCampaignKeys[key] = true;
        }
        previousPermissions[key] = false;
        return;
      }

      previousPermissions[key] = true;
      // A failed storage deletion must not restore revoked context on regrant.
      if (revokedCampaignKeys[key]) delete stored[key];
      if (!campaignValues[key] && stored[key]) campaignValues[key] = stored[key];
      if (campaignValues[key]) stored[key] = campaignValues[key];
    });

    try {
      if (Object.keys(stored).length) {
        window.sessionStorage.setItem(campaignStorageKey, JSON.stringify(stored));
      } else {
        window.sessionStorage.removeItem(campaignStorageKey);
      }
    } catch (error) {
      return;
    }
  }

  function updatePlateformLink(link) {
    var url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.hostname !== 'cantinaantica.plateform.app') return;

    campaignKeys.forEach(function (key) {
      if (!storageAllowedFor(key)) {
        // delete() also removes duplicate parameters already present in markup.
        url.searchParams.delete(key);
      } else if (campaignValues[key] && !url.searchParams.has(key)) {
        url.searchParams.set(key, campaignValues[key]);
      }
    });

    if (link.href !== url.toString()) link.href = url.toString();
  }

  function updatePlateformLinks() {
    document.querySelectorAll('a[href]').forEach(updatePlateformLink);
  }

  window.dataLayer = window.dataLayer || [];
  var menuPage = document.querySelector('[data-menu-page]');
  var menuViewSent = false;

  function refreshCampaignContext() {
    refreshStoredCampaignContext();
    updatePlateformLinks();
    trackMenuViewOnce();
  }

  document.addEventListener('visitorConsentCollected', refreshCampaignContext);
  refreshCampaignContext();

  if (!customerPrivacy() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) refreshCampaignContext();
      }
    );
  }

  // Recheck changed/new links before navigation and before diagnostic listeners.
  function preparePlateformNavigation(event) {
    var target = event.target;
    var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!link) return;
    if (!customerPrivacy()) refreshStoredCampaignContext();
    updatePlateformLink(link);
  }

  ['click', 'auxclick', 'contextmenu'].forEach(function (eventName) {
    document.addEventListener(eventName, preparePlateformNavigation, true);
  });

  function trackingAllowed() {
    var privacy = customerPrivacy();
    if (!privacy) return false;

    try {
      return (
        (typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) ||
        (typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
      );
    } catch (error) {
      return false;
    }
  }

  function pushDataLayerEvent(eventName, payload) {
    if (!trackingAllowed()) return false;

    window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    return true;
  }

  function isPlateformReservation(destination) {
    try {
      var url = new URL(destination, window.location.origin);
      return url.hostname === 'cantinaantica.plateform.app' && url.pathname.indexOf('/reserve') === 0;
    } catch (error) {
      return false;
    }
  }

  function trackMenuViewOnce() {
    if (!menuPage || menuViewSent) return;

    menuViewSent = pushDataLayerEvent('view_menu', {
      page_path: window.location.pathname
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-track]');
    if (!trigger) return;

    var destination = trigger.getAttribute('href') || '';
    var eventName = trigger.dataset.track;

    if (eventName === 'click_book') eventName = 'click_reserve';
    if (eventName === 'click_takeaway') eventName = 'click_asporto';

    var payload = {
      link_url: destination,
      page_path: window.location.pathname,
      cta_location: trigger.dataset.trackLocation || 'unspecified'
    };

    pushDataLayerEvent(eventName, payload);

    if (trigger.dataset.bookingStart === 'true' || (eventName === 'click_reserve' && isPlateformReservation(destination))) {
      pushDataLayerEvent('booking_start', payload);
    }
  });

  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  var cookieButton = document.querySelector('[data-cookie-preferences]');
  if (cookieButton) {
    function getPrivacyPreferencesController() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        return function () {
          window.privacyBanner.showPreferences();
        };
      }

      var nativeButton = document.querySelector(
        '#shopify-privacy-banner-button-div button, [data-shopify-privacy-settings-button]'
      );

      if (nativeButton && nativeButton !== cookieButton) {
        return function () {
          nativeButton.click();
        };
      }

      return null;
    }

    function syncCookieButton() {
      cookieButton.hidden = !getPrivacyPreferencesController();
    }

    cookieButton.addEventListener('click', function () {
      var openPreferences = getPrivacyPreferencesController();
      if (openPreferences) openPreferences();
      else cookieButton.hidden = true;
    });

    [0, 500, 1500, 3000].forEach(function (delay) {
      window.setTimeout(syncCookieButton, delay);
    });
  }
})();
